import { searchLabels } from 'api/endpoints/jelledFromFileSpecWithTransformer'
import { Label, SearchLabelsParams } from 'api/model'
import debounce from 'lodash.debounce'
import { useRef, useState } from 'react'
import { useSetRecoilState } from 'recoil'
import { toastAtom } from 'state'

function useSearchTags() {
  const setToast = useSetRecoilState(toastAtom)

  const [query, setQuery] = useState('')
  const pendingInputValue = useRef(query)
  const [options, setOptions] = useState<readonly string[]>([])
  const [isLoading, setIsLoading] = useState(false)

  const debounceQueryUpdate = useRef(
    debounce(async (query: string, activeOrganization: string) => {
      if (!query) {
        setOptions([])
        return
      }

      const params: SearchLabelsParams = {
        q: query + ' in:name type:document',
      }

      try {
        setIsLoading(true)
        const response = await searchLabels(activeOrganization, params)
        if (query !== pendingInputValue.current) {
          return
        }

        const tags: string[] = response.data?.items.map((l: Label) => l.name) ?? []

        setOptions(tags)
      } catch (error) {
        setToast({ title: 'Failed to search tags', severity: 'error' })
      } finally {
        setIsLoading(false)
      }
    }, 500)
  ).current

  return {
    query,
    setQuery,
    pendingInputValue,
    debounceQueryUpdate,
    options,
    setOptions,
    isLoading,
    setIsLoading,
  }
}

export { useSearchTags }
